import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import { AppBar, Box, Button, Dialog, Drawer, Link, ToggleButton, ToggleButtonGroup, Toolbar } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import i18next from 'i18next';
import imgurl from '../assests/images/imgurl';
import HtmlContentMaster from '../utils/HtmlContentMaster';
import { postApi } from '../api/services';
import { gTagTracking, serviceDown, trackEvent } from '../utils/UtilityFunctions';
import MobileHeader from './MobileHeader';
import { setgender } from '../Reducers/reducer';
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const TutorialVideo = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch();
  const [play, setPlay] = useState(true)
  const [mute, setMute] = useState(true)
  const [openDialog, setOpenDialog] = useState(true)
  const [gender, setGender] = useState('')
  const [isMobile, setIsMobile] = useState(false)
  const [open, setOpen] = useState(false);
  const [privacyDrawer, setPrivacyDrawer] = useState(false);
  const [termsDrawer, setTermsDrawer] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  let { Gender } = useSelector((state) => state.user.profile);
  const channel = localStorage.getItem('channel')

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, []);

  useEffect(() => {
    if(Gender == ''){
      setGender(localStorage.getItem('gender'))
    } else {
      setGender(Gender)
    }
    // play && setMute(false)
  }, [])

  useEffect(() => {
    if (openDialog) {
      const timer = setTimeout(() => {
        setPlay(true)
        // setMute(false)
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [openDialog]);


  const addUser = async () => {
    let userObj = JSON.parse(localStorage.getItem('user_obj'))
    if(!userObj) {
      setIsLoading(true)
      let genderVal = capitalizeFirstLetter(gender)
      let params = {
        year_of_birth: '',
        gender: genderVal,
        first_name: '',
        last_name: '',
        doctor_referral_code: null,
        nurse_referral_code: null,
        clinic_referral_code: null
      }
      console.log("add_patient params", params);
      try {
        let res = await postApi('add_patient', params)
        console.log("add_patient res", res);
        await trackEvent('no_signup_initiated', 'success', " ", localStorage.getItem('phno'), res.user_obj.user_id)
        await gTagTracking('no_signup_initiated', {
          action: 'success',
          error: " ",
          mobile_number: localStorage.getItem('phno'),
          user_id: res.user_obj.user_id,
        })
        setIsLoading(false)
        if(res.error) {
          serviceDown(navigate, localStorage.getItem('channel') === 'alopexia-ads' ? 'c1' : 'start-test')
        } else {
          localStorage.setItem('user_obj', JSON.stringify(res.user_obj))
          navigate("/taketest", { replace: true, state: "onboardingComplete" })
        }
      } catch (err) {
        console.log("err", err);
        await trackEvent('no_signup_initiated', 'fail', err, " ", "")
        await gTagTracking('no_signup_initiated', {
          action: 'fail',
          error: err,
          mobile_number: " ",
          user_id: "",
        })
        setIsLoading(false)
      }
    } else {
      navigate("/taketest", { replace: true, state: "needhelp" })
    }
  }

  const capitalizeFirstLetter = (str) => {
    if (typeof str !== 'string' || str.length === 0) {
      return str; // Return as is if not a string or empty
    }
    return str.charAt(0)?.toUpperCase() + str.slice(1);
  }

  const handleDrawer = (which, to) => {
    if (which === "privacy" && to === "open") {
      setPrivacyDrawer(true);
    } else if (which === "privacy" && to === "close") {
      setPrivacyDrawer(false);
    } else if (which === "terms" && to === "open") {
      setTermsDrawer(true);
    } else if (which === "terms" && to === "close") {
      setTermsDrawer(false);
    }
  };

  const handleToggleChange = async (event) => {
    try{
      setGender(event.target.value);
      dispatch(setgender(event.target.value))
      localStorage.setItem('gender', event.target.value)
      await trackEvent('gender', 'success', '', localStorage.getItem('phno'))  
      await gTagTracking('gender', {
        action: 'success',
        error: '',
        mobile_number: localStorage.getItem('phno')
      })
    } catch (err) {
      console.log("err", err);
      await trackEvent('gender', 'fail', err, localStorage.getItem('phno'))  
      await gTagTracking('gender', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
    }
  };

  return (
    <div className={channel === 'alopexia-ads' ? "tutorialVidPage ads" : "tutorialVidPage"}>
      {
        isMobile && 
          <Box sx={{ flexGrow: 1 }} className="mobileAppBar loginpagenavbar">
            <AppBar position="static">
              <Toolbar sx={{ justifyContent: "center", position: "relative" }}>
                {/* Logo in the center */}
                <Link to="https://alopexia.com/" className="linkingIconHeader">
                  <img
                    src={imgurl.hairlossaiLogo}
                    alt="New Logo"
                    className="headerLogo mainlogo"
                    
                  />
                </Link>
              </Toolbar>
            </AppBar> 
          </Box>
      }
      <Dialog
        open={openDialog}
        className='tutorialVidDialog'
        maxWidth={"sm"}
      >
        {
          (location?.state?.from === 'expandVideo' || location?.state?.from === 'needhelp') &&
            <div 
              onClick={() => 
              {
                location?.state?.from === 'expandVideo' ? 
                  navigate('/onboardingslider', {state: { from: 'expandVideo' }})
                    :
                  navigate("/taketest", { replace: true, state: location?.state?.from ? "needhelp" : "onboardingComplete"})
              }
              } 
              className="closeicon expandVid cursor-pointer"
            >
              <CancelOutlinedIcon></CancelOutlinedIcon>
            </div>
        }
        {
          !(location?.state?.from === 'expandVideo' || location?.state?.from === 'needhelp') &&
          <ToggleButtonGroup
            exclusive
            onChange={(e) => handleToggleChange(e)}
            aria-label="text alignment"
            className="switchGenderToggle"
            value={gender}
          >
            <ToggleButton
              value="male"
              aria-label="left aligned"
              className="toggleGenderbutton maleButton"
            >
              <MaleIcon className='mr-5px'/>{i18next.t("Male")}
            </ToggleButton>
            <ToggleButton
              value="female"
              aria-label="centered"
              className="toggleGenderbutton maleButton"
            >
              <FemaleIcon className='mr-5px'/>{i18next.t("Female")}
            </ToggleButton>
          </ToggleButtonGroup>
        }
        {
          !(location?.state?.from === 'needhelp') && gender?.toUpperCase() === "FEMALE" &&
            <p className='womennote'>
              <span>
                {i18next.t("Please Note: ")}
              </span>
              {i18next.t("All women can take the AI hair loss test. However, the anti-DHT medicines that we recommend are contraindicated for women of reproductive age and is only advised for those who are menopausal.")}
            </p>
        }
        <div>
        <h3 className='mt-10px mb-10px text-center'>{i18next.t("Hair Test Guide")}</h3>
        <div className='reactPlayerContainer'>
          <ReactPlayer
            url={
              gender?.toUpperCase() === "MALE"
                ? "https://res.cloudinary.com/dgeiynco8/video/upload/v1751006680/tutorial_male_lcmqfi.mp4"
                : "https://res.cloudinary.com/dgeiynco8/video/upload/v1751006705/tutorial_female_a0puem.mp4"
            }
            playing={play}
            controls={false}
            muted={mute}
            playsinline
            onEnded={() => setPlay(false)}
            onError={err => console.warn("Video playback error:", err)}
            config={{
              file: {
                attributes: {
                  playsInline: true,
                  webkitplaysinline: "true",
                },
              },
            }}
            className='tutorialVideoPlayer'
          />
        </div>
        <div 
          className={
            // (location?.state?.from === 'expandVideo' || location?.state?.from === 'needhelp') ?
            //   'btnControls expandVid' 
            //     : 
            gender?.toUpperCase() === 'MALE' ? 
              'btnControls' 
                : 
            isMobile ? 
              'btnControls female mobile' 
                : 
              'btnControls female'
            }>
          <Button onClick={() => setMute(!mute)}>
            {
              mute ?
                <VolumeOffIcon/> 
                  :
                <VolumeUpIcon/>
            }
          </Button>
          {
            !play && 
              <Button onClick={() => setPlay(true)}>
                <ReplayIcon/>
              </Button>
          }
        </div>
        {
          <>
            <div className='continuebtndiv'>
              <Button onClick={() => addUser()}>
                {i18next.t("Continue")}
              </Button>
            </div>
            {
              !location?.state?.from &&
              <div className="checkBoxTerms">
                  <>
                    {i18next.t("By continuing you agree to the")}{" "}
                    <Link
                        target="_blank"
                        className="linkText cursor-pointer"
                        onClick={() => {
                          setOpen(true)
                        }}
                      >
                        {i18next.t("terms of use")}
                    </Link>
                    &nbsp; {i18next.t("and")} &nbsp;
                    <Link
                      target="_blank"
                      className="linkText cursor-pointer"
                      onClick={() => {
                        handleDrawer("privacy", "open")
                      }}
                    >
                      {i18next.t("privacy policy.")}
                    </Link>
                  </>
              </div>        
            }
          </>
        }

        </div>
      </Dialog>
      <Drawer
        className="imguplddrwr trmscnddrwr"
        anchor={"bottom"}
        open={open}
        onClose={() => setOpen(false)}
      >
        <div className="drawerhead">
          <p></p>
          <div className="ellipse cursor-pointer" onClick={() => setOpen(false)}>
            <p>X</p>
          </div>
        </div>
        <div className="WordSection1">
          <h1 className='cursor-pointer'>{i18next.t("Terms of Use")}</h1>
          <p className="MsoNormal">
            {i18next.t("Effective Date: 1 Jan, 2025")}
          </p>
          <h2>{i18next.t("Welcome")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "Welcome to the Alopexia website and application! These Terms of Use (“Terms”) govern your use of the services (“Service”) provided by Centa Bio (“us,” “we,” or “our”). By accessing or using the Alopexia website and/or application, you agree to be bound by these Terms."
            )}{" "}
            <br></br>
            <br></br>
          </p>
          <p className="MsoNormal">
            {i18next.t(
              "If you disagree with any part of these Terms, you may not access the Service."
            )}
          </p>
          <h2>{i18next.t("1. Use of the Service")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "Alopexia offers AI-driven personalized haircare solutions, including scalp assessment, treatment recommendations, and progress tracking. The Service is designed to provide actionable insights and personalized treatment options for users experiencing hair loss."
            )}
            <br></br>
            <br></br>
            {i18next.t("By using the Service, you agree to:")}
            <br></br>- {i18next.t("Use the Service only")}
            {i18next.t("for personal, non-commercial purposes.")}
            <br></br>- {i18next.t("Follow all")}
            {i18next.t(
              "applicable laws and regulations in your use of the Service."
            )}
          </p>
          <h2>{i18next.t("2. Eligibility")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "You must be at least 18 years old and a male to use the Service and capable of entering into a lawful agreement. By using the Service, you confirm that you meet these eligibility criteria."
            )}
          </p>
          <h2>{i18next.t("3. Account Creation")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "Certain features may require you to create an account. You agree to:"
            )}
            <br></br>-{" "}
            {i18next.t(
              "Provide accurate and up-to-date information during registration."
            )}
            <br></br>-{" "}
            {i18next.t(
              "Maintain the confidentiality of your account credentials."
            )}
            <br></br>-{" "}
            {i18next.t(
              "Notify us immediately of any unauthorized access to your account."
            )}
            <br></br>
            <br></br>
            {i18next.t(
              "You are solely responsible for activities under your account."
            )}
          </p>
          <h2>{i18next.t("4. Acceptable Use")}</h2>
          <p className="MsoNormal">
            {i18next.t("When using the Service, you agree not to:")}
            <br></br>-{" "}
            {i18next.t(
              "Interfere with or disrupt the functionality of the Service."
            )}
            <br></br>-{" "}
            {i18next.t(
              "Use the Service for illegal or unauthorized purposes."
            )}
            <br></br>-{" "}
            {i18next.t(
              "Upload harmful content, such as viruses, worms, or other malicious software."
            )}
            <br></br>-{" "}
            {i18next.t(
              "Engage in any activity that compromises the security or integrity of the Service."
            )}
          </p>
          <h2>{i18next.t("5. Intellectual Property Rights")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "All content, features, and functionality of the Service are the exclusive property of Centa Bio."
            )}{" "}
            <br></br>
            {i18next.t(
              "Unauthorized use of trademarks, logos, or proprietary materials is prohibited without prior written consent."
            )}
          </p>
          <h2>{i18next.t("6. Privacy")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "Your use of the Service is governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information, including sensitive health data. Please review our Privacy Policy for more details."
            )}
          </p>
          <h2>{i18next.t("7. Data Usage and Sharing")}</h2>
          <p className="MsoNormal">
            {i18next.t("By using the Service, you agree to:")}
            <br></br>-{" "}
            {i18next.t(
              "Allow Centa Bio to collect and process data, including health-related data, to deliver personalized solutions."
            )}
            <br></br>-{" "}
            {i18next.t(
              "Consent to data aggregation for research and service improvement."
            )}
            <br></br>-{" "}
            {i18next.t(
              "Understand that we will not share your personally identifiable information without your explicit consent, except as required by law."
            )}
          </p>
          <h2>{i18next.t("8. Disclaimer of Warranties")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "The Service is provided on an “as is” and “as available” basis. Centa Bio does not guarantee uninterrupted access, error-free functionality, or the accuracy of the results generated by the AI-driven assessment."
            )}
          </p>
          <h2>{i18next.t("9. Limitation of Liability")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "To the fullest extent permitted by law, Centa Bio shall not be liable for:"
            )}
            <br></br>-{" "}
            {i18next.t("Indirect, incidental, or consequential damages.")}
            <br></br>-{" "}
            {i18next.t(
              "Loss of data, profits, or goodwill arising from your use of the Service."
            )}
          </p>
          <h2>{i18next.t("10. Changes to the Terms of Use")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "We reserve the right to update these Terms at any time. Any changes will be posted on this page, with the updated effective date. Continued use of the Service constitutes acceptance of the revised Terms."
            )}
          </p>
          <h2>{i18next.t("11. Governing Law")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "These Terms shall be governed by and construed in accordance with the laws of [Insert Governing Jurisdiction], without regard to its conflict of law principles."
            )}
          </p>
          <h2>{i18next.t("12. Contact Us")}</h2>
          <p className="MsoNormal">
            {i18next.t(
              "For questions or concerns regarding these Terms, please contact us at:"
            )}
            <br></br>- {i18next.t("Email")}: contact@alopexia.ai
            <br></br>- {i18next.t("Address")}: Centa Biotech SL,Alameda
            Principal 11,9001 Malaga, Spain.
            <br></br>
            {i18next.t(
              "By accessing or using the Alopexia website and application, you acknowledge that you have read, understood, and agree to these Terms of Use."
            )}
          </p>
        </div>
      </Drawer>
      <Drawer
        className="privacypolicydrawer"
        anchor={"bottom"}
        open={privacyDrawer}
        onClose={() => handleDrawer("privacy", "close")}
      >
        <div className="drawerhead">
          <div
            className="ellipse cursor-pointer"
            onClick={() => handleDrawer("privacy", "close")}
          >
            <p>X</p>
          </div>
        </div>
        <HtmlContentMaster keyName={"privacypolicy"} />
      </Drawer>
    </div>
  )
}

export default TutorialVideo